<template>
    <div class="apprentice-simple-card">
        <p
            v-if="has_forms"
            style="margin-bottom: 30px">
            {{ $t('group_pair.fill_in_fields_below_the_answers_given_will_be_assessed_by_teacher') }}
        </p>

        <b-alert
            v-if="has_required"
            variant="warning"
            show>
            {{ $t('common.fields_with_an_asterisk_are_mandatory') }}
        </b-alert>

        <div v-if="groupIn.group_pair_options.topic === 1">
            <b-form-group
                :label="groupIn.group_pair_options.topic_option === 1 ? $t('group.settings.subject')+'*' : $t('group.settings.subject')"
                label-for="input-2">
                <div v-if="overSubjectLength > 0">
                    <b-alert
                        show
                        variant="danger">
                        {{ $t('group_pair.too_many_characters', { amount: overSubjectLength }) }}
                    </b-alert>
                </div>
                <b-form-input
                    id="input-2"
                    v-model="subject"
                    :required="groupIn.group_pair_options.topic_option === 1"
                    :placeholder="$t('group_pair.fill_the_subject_in')"></b-form-input>
            </b-form-group>
        </div>

        <div v-if="groupIn.group_pair_options.course === 1">
            <b-form-group :label="groupIn.group_pair_options.course_option === 1 ? $t('group_pair.courses')+'*' : $t('group_pair.courses')">
                <div v-if="course_total_error">
                    <b-alert
                        show
                        variant="danger">
                        {{ course_error_text }}
                    </b-alert>
                </div>

                <design-2021-apprentice-multiselect-component
                    id="group-pair-courses-create"
                    :placeholder="$t('group_pair.select_profile_courses')"
                    @input="inputCourses($event)"
                    label="name"
                    :options="coursesIn"
                    :show-labels="false"
                    :selected-in="selectedCourses"
                    :multiple-select="true">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>

        <div v-if="groupIn.group_pair_options.course_student_link">
            <div v-for="student of students">
                <design-2021-group-pair-create-form-select-courses-student-component
                    :group-in="groupIn"
                    :group-pair-group-in="groupPairGroupIn"
                    :student-in="student"
                    :courses-in="coursesIn"
                    @log="updatePersonalCourses($event)">
                </design-2021-group-pair-create-form-select-courses-student-component>
            </div>
        </div>

        <div
            v-if="groupIn.group_pair_options.argumentation === 1"
            style="margin-bottom: 25px">
            <b-form-group
                :label="groupIn.group_pair_options.argumentation_option === 1 ? $t('group_pair.motivation')+'*' : $t('group_pair.motivation')"
                label-for="input-2">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="textarea"
                    v-model="motivation"
                    :placeholder="$t('group_pair.fill_your_motivation_in')"
                    rows="3"
                    :required="groupIn.group_pair_options.argumentation_option === 1"
                    max-rows="6"></b-form-textarea>
            </b-form-group>

            <div
                v-if="groupIn.group_pair_options.upload === 1"
                style="margin-bottom: 25px">
                <b-form-group
                    :label="groupIn.group_pair_options.upload_option === 1 ? $t('group_pair.files')+'*' : $t('group_pair.files')"
                    label-for="input-3">
                    <b-form-file
                        class="apprentice-file-upload"
                        v-model="file"
                        :placeholder="fileIn ? $t('group_pair.current_file')+': ' + fileIn.file.full_name : $t('group_pair.choose_file')"
                        :drop-placeholder="$t('group_pair.place_your_file_here')">
                    </b-form-file>
                </b-form-group>
            </div>
        </div>

        <b-button
            @click="createGroup"
            variant="primary">
            {{ $t('group_pair.edit_request') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-edit-form-component',
    props: [
        'groupIn',
        'coursesIn',
        'subjectIn',
        'groupPairGroupIn',
        'motivationIn',
        'studentsIn',
        'selectedCoursesIn',
        'fileIn',
    ],
    data() {
        return {
            has_forms: false,
            has_required: false,
            subject: this.subjectIn ? this.subjectIn : '',
            motivation: this.motivationIn ? this.motivationIn : '',
            file: null,
            students: this.studentsIn,
            selectedCourses: this.selectedCoursesIn ? this.selectedCoursesIn : [],
            personalSelectedCourses: [],
            selectedCourse: null,
            course_total_error: false,
            course_personal_error: false,
            maxSubjectLength: 65535,
        };
    },
    computed: {
        course_error_text() {
            const min = this.groupIn.group_pair_options.course_min;
            const max = this.groupIn.group_pair_options.course_max;

            if (min !== null && max === null) {
                return this.$t('group_pair.courses_must_be_at_least', { amount: min });
            }

            if (min === null && max !== null) {
                return this.$t('group_pair.courses_must_be_maximum', { amount: max });
            }

            return this.$t('group_pair.amount_of_courses_must_be_between', { min: min, max: max });
        },
        overSubjectLength() {
            return this.subject.length - this.maxSubjectLength;
        },
    },
    methods: {
        updatePersonalCourses(data) {
            this.students.map((student) => {
                if (student.id === data.studentId) {
                    student.selectedCourses = data.selectedCourses;
                }
                return student;
            });
            if (this.personalSelectedCourses.find((student) => student.id === data.studentId)) {
                this.personalSelectedCourses = this.personalSelectedCourses.map((student) => {
                    if (student.id === data.studentId) {
                        student.selectedCourses = data.selectedCourses;
                    }
                    return student;
                });
            } else {
                this.personalSelectedCourses.push({
                    id: data.studentId,
                    selectedCourses: data.selectedCourses,
                });
            }
        },
        inputCourses(courses) {
            this.selectedCourses = courses;
        },
        removeSelectedCourse(id) {
            this.selectedCourses = this.selectedCourses.filter((course) => course.id !== id);
        },
        addFile(file) {
            this.files.push(file);
        },
        fileRemove(lastModified) {
            this.files = this.files.filter((item) => item.lastModified !== lastModified);
        },
        createGroup() {
            let data = {
                subject: this.subject,
                motivation: this.motivation,
                selectedCourses: this.selectedCourses,
                personalSelectedCourses: this.personalSelectedCourses,
                file: this.file,
                course_total_error: this.course_total_error,
                course_personal_error: this.course_personal_error,
                overSubjectLength: this.overSubjectLength,
            };

            this.$emit('create-group', data);
        },
    },
    watch: {
        selectedCourse: function (value) {
            if (!value) {
                return;
            }
            this.selectedCourses.push(value);
            this.selectedCourse = null;
        },
        selectedCourses: function (value) {
            const min = this.groupIn.group_pair_options.course_min;
            const max = this.groupIn.group_pair_options.course_max;

            if (min !== null && max === null) {
                this.course_total_error = value.length < min;
            } else if (min === null && max !== null) {
                this.course_total_error = value.length > max;
            } else if (min === null && max === null) {
                this.course_total_error = false;
            } else if (min === max && value.length !== min) {
                this.course_total_error = true;
            } else this.course_total_error = !(value.length >= min && value.length <= max);
        },
        personalSelectedCourses: function (personalSelectCourses) {
            if (this.groupIn.group_pair_options.course_student_link) {
                const min = this.groupIn.group_pair_options.course_min;
                const max = this.groupIn.group_pair_options.course_max;
                personalSelectCourses.forEach((value) => {
                    if (min !== null && max === null) {
                        this.course_personal_error = value.selectedCourses.length < min;
                    } else if (min === null && max !== null) {
                        this.course_personal_error = value.selectedCourses.length > max;
                    } else if (min === null && max === null) {
                        this.course_personal_error = false;
                    } else if (min === max && value.selectedCourses.length !== min) {
                        this.course_personal_error = true;
                    } else
                        this.course_personal_error = !(
                            value.selectedCourses.length >= min && value.selectedCourses.length <= max
                        );
                });
            } else {
                this.course_personal_error = false;
            }
        },
    },
    mounted() {
        this.has_forms =
            this.groupIn.group_pair_options.course ||
            this.groupIn.group_pair_options.topic ||
            this.groupIn.group_pair_options.argumentation;

        this.has_required =
            this.has_forms &&
            (this.groupIn.group_pair_options.coure_option === 1 ||
                this.groupIn.group_pair_options.topic_option === 1 ||
                this.groupIn.group_pair_options.argumentation_option === 1);

        this.personalSelectedCourses = this.groupPairGroupIn.group_pair_students.map((student) => {
            return {
                id: student.user_id,
                selectedCourses: student.courses,
            };
        });
    },
};
</script>

<style scoped></style>
